import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { Form } from '@ant-design/compatible';

import { formatDecimal } from '../../../services/NumberService';

class InputDecimal extends React.Component {
  onChange = event => event.target.value = formatDecimal(event.target.value, 2)

  render() {
    const { name, rules, initialValue, placeholder, prefix, form, type, formItemStyle, disabled } = this.props
    const inputError = form.isFieldTouched(name) && form.getFieldError(name)
    return (
      <Form.Item
        style={formItemStyle}
        validateStatus={inputError ? 'error' : ''}
        help={inputError || ''}>
        {form.getFieldDecorator(name, {
          rules,
          initialValue: (initialValue === undefined || initialValue === null || initialValue === '') ?
            '' : initialValue.toFixed(2).replace('.', ','),
        })(
          <Input onChange={this.onChange} name={name} autoComplete="off" prefix={prefix} placeholder={placeholder} type={type} disabled={disabled} />
        )}
      </Form.Item>
    )
  }
}

InputDecimal.propTypes = {
  form: PropTypes.object.isRequired,
  rules: PropTypes.array,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  prefix: PropTypes.element,
  formItemStyle: PropTypes.object,
  disabled: PropTypes.bool
}

InputDecimal.defaultProps = {
  type: "text"
}

export default InputDecimal
